import { render } from "./date.view.vue?vue&type=template&id=59d6f634&scoped=true&ts=true"
import script from "./date.view.vue?vue&type=script&lang=ts"
export * from "./date.view.vue?vue&type=script&lang=ts"

import "./date.view.vue?vue&type=style&index=0&id=59d6f634&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d6f634"]])

export default __exports__